import axios from 'axios';

import { WizardProposal } from '../../entities/wizard-proposal';
import { auth } from '../firebase/firebase';
import { API_BASE_URL } from './index';

const getHeaders = async () => {
  const idToken = await auth.currentUser?.getIdToken();
  return { Authorization: `Bearer ${idToken}` };
};

export const getWizardProposal = async (): Promise<WizardProposal | null> => {
  const headers = await getHeaders();
  const { data } = await axios.get<{ proposal: WizardProposal | null }>(`${API_BASE_URL}/api/wizard/proposal`, {
    headers,
  });
  return data.proposal;
};

export const retryWizardProposal = async (): Promise<WizardProposal> => {
  const headers = await getHeaders();
  const { data } = await axios.post<{ proposal: WizardProposal }>(
    `${API_BASE_URL}/api/wizard/proposal/retry`,
    {},
    { headers },
  );
  return data.proposal;
};
